export function NotificationBell({
  hasUnread = true,
  className = '',
  size = 44,
}: {
  hasUnread?: boolean;
  className?: string;
  size?: number | string;
}) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      height={size}
      viewBox="0 0 44 44"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      {hasUnread ? (
        <>
          <path
            d="M33.2449 20.1667C34.3118 30.0218 38.5 33.0001 38.5 33.0001H5.5C5.5 33.0001 11 29.089 11 15.4001C11 12.2882 12.1589 9.30379 14.2218 7.10336C16.2847 4.90293 19.0826 3.66675 22 3.66675C22.6184 3.66675 23.2315 3.7223 23.8333 3.83081"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
          />
          <path
            d="M33 14.6667C36.0376 14.6667 38.5 12.2043 38.5 9.16675C38.5 6.12918 36.0376 3.66675 33 3.66675C29.9624 3.66675 27.5 6.12918 27.5 9.16675C27.5 12.2043 29.9624 14.6667 33 14.6667Z"
            fill="#E6332A"
          />
        </>
      ) : (
        <path
          d="M29.7781 7.09677C27.7152 4.89634 24.9173 3.66675 22 3.66675C19.0827 3.66675 16.2848 4.89634 14.2219 7.09677C12.159 9.2972 11.0001 12.2816 11.0001 15.4C11.0001 29.0889 5.5 33 5.5 33H22H38.5C38.5 33 33 29.0889 33 15.4C33 12.2816 31.8411 9.2972 29.7781 7.09677Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
      )}
      <path
        d="M25.1715 38.5C24.8491 39.0556 24.3865 39.5169 23.8299 39.8375C23.2732 40.1581 22.6422 40.3268 21.9998 40.3268C21.3574 40.3268 20.7263 40.1581 20.1697 39.8375C19.6131 39.5169 19.1504 39.0556 18.8281 38.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  );
}
